import { NavLink } from "react-router-dom";
import { filterNavByRole } from "@/config/navigation";
import { cn } from "@/lib/utils";

export default function Sidebar({ user }) {
  const sections = filterNavByRole(user.role);

  return (
    <aside
      data-testid="app-sidebar"
      className="hidden md:flex md:flex-col fixed left-0 top-0 h-screen w-[264px] bg-white border-r border-border z-30"
    >
      {/* Brand */}
      <div className="px-5 py-5 flex items-center gap-3 border-b border-border">
        <img
          src="/brand/logo.webp"
          alt="Anjos de Patas"
          className="h-14 w-14 object-contain shrink-0"
        />
        <div className="min-w-0">
          <p className="font-heading font-bold text-brand-turquoise leading-tight truncate text-lg">
            Anjos de Patas
          </p>
          <p className="text-[10px] font-semibold uppercase tracking-widest text-brand-lilac">
            Reabilitação e Equoterapia
          </p>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto py-4">
        {sections.map((section) => (
          <div key={section.label} className="px-3 mb-5">
            <p className="px-3 mb-2 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
              {section.label}
            </p>
            <ul className="space-y-0.5">
              {section.items.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    data-testid={`nav-link-${item.to.replace("/", "")}`}
                    className={({ isActive }) =>
                      cn(
                        "flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors",
                        isActive
                          ? "bg-secondary text-secondary-foreground font-semibold"
                          : "text-slate-600 hover:bg-secondary/60 hover:text-secondary-foreground"
                      )
                    }
                  >
                    <item.icon className="h-4 w-4 shrink-0" strokeWidth={2} />
                    <span className="truncate">{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      <div className="px-5 py-4 border-t border-border">
        <p className="text-[11px] text-muted-foreground">v0.3.0 · Anjos de Patas</p>
      </div>
    </aside>
  );
}
